import { render, staticRenderFns } from "./SourcingPage.vue?vue&type=template&id=6725cc99&"
import script from "./SourcingPage.vue?vue&type=script&lang=js&"
export * from "./SourcingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports